import { RouteConfig } from 'vue-router';
import MswDpLogin from './msw-dp-login.vue';

export const route: RouteConfig = {
  path: 'login/login-view',
  component: MswDpLogin,
};

export function getDefaultParams() {
  return {};
}

// export default route;
